import React, { Fragment } from "react";
// import { PUZZLES } from "./PUZZLES";
import { BOX_WIDTH } from "./Base";
import { Piece, lsStore, loadRecords, storeRecords, lsLoad } from "./utils";
import "./board.scss";
// import Modal from './modal';
import StarModal from "./modal/starModal";
import { motion } from "framer-motion";
import Cherries from "./static/cherries.svg";
// import cx from "classnames";

export class Move {
  constructor(props) {
    this.index = props.index;
    this.dx = props.dx;
    this.dy = props.dy;
  }
}

export class Board extends React.Component {
  constructor(props) {
    super(props);
    let pieces, size;
    let posStr = this.getPosStr();
    if (posStr) {
      // console.log({ posStr });
      let pieceBounds = {};
      let lines = posStr.replace(/ /g, "\n").split("\n");
      // console.log({ lines });
      size = lines.length;
      for (let y in lines) {
        y = y | 0;
        let line = lines[y];
        for (let x in line) {
          x = x | 0;
          let c = line[x];
          if (c === ".") continue;
          if (pieceBounds[c] === undefined) pieceBounds[c] = [x, y, x, y];
          else {
            let [ox, oy] = pieceBounds[c];
            // console.log(ox, oy);
            pieceBounds[c] = [ox, oy, x, y];
          }
        }
      }
      // console.log(pieceBounds);
      pieces = [];
      for (let piece in pieceBounds) {
        let [x1, y1, x2, y2] = pieceBounds[piece];
        pieces.push(
          new Piece({
            isMain: piece === "+",
            x: x1,
            y: y1,
            dx: x2 - x1 + 1,
            dy: y2 - y1 + 1,
          })
        );
      }
    } else {
      size = props.size;
      pieces = props.pieces;
    }
    // Create a [y][x] -> piece index mapping
    let board = [];
    for (let y = 0; y < size; y++) {
      let row = [];
      for (let x = 0; x < size; x++) row.push(-1);
      board.push(row);
    }
    for (let index in pieces) {
      let piece = pieces[index];
      this.place(board, piece, index | 0);
    }
    this.drag = this.drag.bind(this);
    this.dragEnd = this.dragEnd.bind(this);
    this.state = {
      // Board state stuff
      size: size,
      pieces: pieces,
      board: board,
      moves: [],
      futureMoves: [],
      // Dragging stuff
      draggingIndex: null,
      dragStartX: null,
      dragStartY: null,
      offsetX: null,
      offsetY: null,
      // For velocity calculations
      dragLastX: null,
      showLevelCompleteModal: false,
    };
  }
  place(board, piece, index) {
    for (let x = piece.x; x < piece.x + piece.dx; x++)
      for (let y = piece.y; y < piece.y + piece.dy; y++) board[y][x] = index;
  }
  // Make a move. Sentinel value of null goes forward or backwards in history, depending on 'reverse'
  doMove(move, reverse) {
    let moves = this.state.moves;
    let futureMoves = this.state.futureMoves;
    if (move !== null) {
      moves.push(move);
      futureMoves = [];
    } else {
      if (reverse) {
        move = moves.pop();
        futureMoves.push(move);
      } else {
        move = futureMoves.pop();
        moves.push(move);
      }
    }
    let piece = this.state.pieces[move ? move.index : 0];
    // Remove old piece
    this.place(this.state.board, piece, -1);
    // Move piece position
    let dx = move.dx,
      dy = move.dy;
    if (reverse) {
      dx = -dx;
      dy = -dy;
    }
    piece.x += dx;
    piece.y += dy;
    // Place new piece
    this.place(this.state.board, piece, move.index);
    this.props.setMoves(moves);
    this.setState({
      board: this.state.board,
      pieces: this.state.pieces,
      moves: moves,
      futureMoves: futureMoves,
    });
    // Store the backward/forward move history into local storage, as well as
    // this puzzle's initial configuration so we can verify them if the page gets reloaded
    lsStore(
      "current-puzzle-moves",
      moves.map((m) => [m.index, m.dx, m.dy])
    );
    lsStore(
      "current-puzzle-future-moves",
      futureMoves.map((m) => [m.index, m.dx, m.dy])
    );
    lsStore("current-puzzle-pos-str", this.getPosStr());
  }
  isWon() {
    if (this.state.moves === 0) return false;
    for (let piece of this.state.pieces)
      if (piece.isMain) {
        const result = piece.x + piece.dx >= this.state.size;
        if (result) {
          setTimeout(() => {
            this.setState({showLevelCompleteModal: true});
          }, 1000);
        }
        return result;
      }
    throw Error("What?");
  }
  getPosStr() {
    let posStr = this.props.posStr;
    if (this.props.puzzleNumber !== null)
      posStr = this.props.PUZZLES[this.props.puzzleNumber].board;
    return posStr;
  }
  updateRecords() {
    if (!this.isWon()) throw Error("bad update");
    let moves = this.state.moves.length;
    // Grab the initial position string, so the records aren't sensitive to the ordering of puzzles.
    let posStr = this.getPosStr();
    if (posStr) {
      let records = loadRecords();
      if (records[posStr] === undefined || records[posStr] > moves) {
        records[posStr] = moves;
        storeRecords(records);
      }
    }
  }
  getPieceBounds(piece) {
    let minX = 0,
      maxX = 0,
      minY = 0,
      maxY = 0;
    if (piece.dx > 1) {
      // Left
      for (
        let x = piece.x - 1;
        x >= 0 && this.state.board[piece.y][x] === -1;
        x--
      )
        minX--;
      // Right
      for (
        let x = piece.x + piece.dx;
        x < this.state.size && this.state.board[piece.y][x] === -1;
        x++
      )
        maxX++;
      // Check for moving the main piece out of bounds for the winning move
      //if (piece.isMain && x == this.state.size)
      //    maxX++;
    } else {
      // Up
      for (
        let y = piece.y - 1;
        y >= 0 && this.state.board[y][piece.x] === -1;
        y--
      )
        minY--;
      // Down
      for (
        let y = piece.y + piece.dy;
        y < this.state.size && this.state.board[y][piece.x] === -1;
        y++
      )
        maxY++;
    }
    return [
      minX * BOX_WIDTH,
      maxX * BOX_WIDTH,
      minY * BOX_WIDTH,
      maxY * BOX_WIDTH,
    ];
  }
  dragStart(index, e) {
    e.stopPropagation();
    e.preventDefault();
    if (e.targetTouches) e = e.targetTouches[0];
    if (e.button !== undefined && e.button !== 0) return;
    this.setState({
      dragStartX: e.pageX,
      dragStartY: e.pageY,
      draggingIndex: index,
    });
  }
  drag(e) {
    // Prevent default whether we're actually dragging a piece or not, to prevent
    // overscrolling. Pretty hacky!
    e.preventDefault();
    if (this.state.draggingIndex === null) return;
    e.stopPropagation();
    if (e.targetTouches) e = e.targetTouches[0];
    this.setState({
      offsetX: e.pageX - this.state.dragStartX,
      offsetY: e.pageY - this.state.dragStartY,
    });
  }
  dragEnd(e) {
    if (this.state.draggingIndex === null) return;
    // console.log(2);
    if (this.props.slideSound && this.props.soundEnabled) {
      if (!this.props.slideSound.paused) {
        this.props.slideSound.pause();
        this.props.slideSound.currentTime = 0;
      }
      this.props.slideSound.play();
    }
    e.stopPropagation();
    e.preventDefault();
    let piece = this.state.pieces[this.state.draggingIndex];
    let [minX, maxX, minY, maxY] = this.getPieceBounds(piece);
    let dx = 0,
      dy = 0;
    if (this.state.offsetX !== null)
      dx = Math.min(maxX, Math.max(minX, this.state.offsetX));
    if (this.state.offsetY !== null)
      dy = Math.min(maxY, Math.max(minY, this.state.offsetY));
    dx = Math.round(dx / BOX_WIDTH);
    dy = Math.round(dy / BOX_WIDTH);
    if (dx || dy) {
      this.doMove(
        new Move({ index: this.state.draggingIndex, dx: dx, dy: dy }),
        null
      );
      // Check for winning states and update local storage to reflect the possible
      // new record. We do this in dragEnd since it's the only place where a "real"
      // move is made (i.e. not retracing history).
      if (this.isWon()) this.updateRecords();
    }
    this.setState({ offsetX: null, offsetY: null, draggingIndex: null });
  }
  resetLevelStats = () => {
    this.props.setMoves(0);
    // this.props.resetTimer();
  };

  resetLevel = () => {
    this.resetLevelStats();
    this.props.selectPuzzle(this.props.puzzleNumber);
  };
  componentWillMount() {
    // Make the mouse move/mouse up event handlers global, since we want to know whenever these
    // things happen, no matter where the mouse is
    document.addEventListener("mousemove", this.drag, { passive: false });
    document.addEventListener("mouseup", this.dragEnd, { passive: false });
    document.addEventListener("touchmove", this.drag, { passive: false });
    document.addEventListener("touchend", this.dragEnd, { passive: false });
    // Try to grab move lists for this puzzle, making sure they're for this puzzle
    let lsPosStr = lsLoad("current-puzzle-pos-str");
    if (lsPosStr === this.getPosStr()) {
      // We have to set these move lists up in a particular order, since doMove overwrites the
      // values in local storage. So first, we load both the backward and forward lists.
      // Then, make all the moves in the backwards list, and finally, load the future moves.
      let moves = lsLoad("current-puzzle-moves") || [];
      let futureMoves = lsLoad("current-puzzle-future-moves") || [];
      for (let [index, dx, dy] of moves)
        this.doMove(new Move({ index: index, dx: dx, dy: dy }));
      this.setState({
        futureMoves: futureMoves.map(
          ([index, dx, dy]) => new Move({ index: index, dx: dx, dy: dy })
        ),
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousemove", this.drag);
    document.removeEventListener("mouseup", this.dragEnd);
    document.removeEventListener("touchmove", this.drag);
    document.removeEventListener("touchend", this.dragEnd);
  }
  getResult = () => {
    const moves = this.props.moves.length;
    const totalMoves = this.props.PUZZLES[this.props.puzzleNumber].moves;
    if (moves === totalMoves) {
      return 3;
    } else if (moves <= totalMoves * 2) {
      return 2;
    } else {
      return 1;
    }
  };
  render() {
    const {PUZZLES } = this.props;
    let record = null;
    let posStr = this.getPosStr();
    if (posStr) {
      let records = loadRecords();
      if (records[posStr] !== undefined) record = records[posStr];
    }
    let optimal = null;
    if (this.props.puzzleNumber !== null)
      optimal = PUZZLES[this.props.puzzleNumber].moves;
    let isWon = this.isWon();
    return (
      <div className="main__container">
        <div className="left__content">
          <span className="level-detail">
            Level {this.props.puzzleNumber + 1}
          </span>
          <div className="left__content-controls">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={(e) => this.resetLevel()}
              className="control-btn"
            >
              <img src={require("./static/restartBtn.svg")} alt="restart" />
            </motion.button>
            <motion.button
              className="control-btn"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={this.props.toggleSound}
            >
              <img src={require("./static/musicBtn.svg")} alt="sound" />
            </motion.button>
            <motion.button
              className="control-btn"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <img
                src={require("./static/soundBtn.svg")}
                alt="music"
                onClick={this.props.toggleMusic}
              />
            </motion.button>
            <motion.button
              animate={
                this.state.moves.length === 0
                  ? { opacity: 0.2 }
                  : { opacity: 1 }
              }
              whileHover={this.state.moves.length !== 0 ? { scale: 1.1 } : {}}
              whileTap={{ scale: 0.9 }}
              
              className="control-btn"
           
              onClick={(e) => {
                if (this.state.moves.length === 0) return;
                this.doMove(null, true);
              }}
            >
              <img src={require("./static/left.svg")} alt="music" />
            </motion.button>
            <motion.button
              animate={
                this.state.futureMoves.length === 0
                  ? { opacity: 0.2 }
                  : { opacity: 1 }
              }
              className="control-btn"
              whileHover={
                this.state.futureMoves.length !== 0 ? { scale: 1.1 } : {}
              }
              whileTap={{ scale: 0.9 }}
              onClick={(e) => {
                if (this.state.futureMoves.length === 0) return;
                this.doMove(null, false);
              }}
            >
              <img src={require("./static/right.svg")} alt="music" />
            </motion.button>

            {/* <input
              type="button"
              disabled={this.state.moves.length === 0}
              onClick={(e) => this.doMove(null, true)}
              className="button-small"
              value="&#x25C0;&#xFE0E;"
            />
            <input
              type="button"
              disabled={this.state.futureMoves.length === 0}
              onClick={(e) => this.doMove(null, false)}
              className="button-small"
              value="&#x25B6;&#xFE0E;"
            /> */}
          </div>
        </div>

        <div className={"main__content"}>
          <StarModal
            pauseGame={this.props.pauseGame}
            isOpen={isWon && this.state.showLevelCompleteModal}
            img={Cherries}
            puzzleNumber={this.props.puzzleNumber}
            levelResult={this.getResult()}
            moves={this.props.moves.length}
            totalMoves={PUZZLES[this.props.puzzleNumber].moves}
            levelCompleteSound={this.props.levelCompleteSound}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                position: 'absolute',
                bottom: 0,
                paddingBottom: '22px'
              }}
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="flex cursor-pointer"
                style={{ marginRight: "45px" }}
                onClick={() => {
                  // console.log("CLICK");
                  this.resetLevelStats();
                  this.props.selectPuzzle(this.props.puzzleNumber);
                }}
              >
                <img
                  src={require("./static/restart.svg")}
                  alt="play-button"
                  className="retry-img"
                />
                <p className="retry-text">RETRY</p>
              </motion.div>

              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                style={{ minWidth: "160px" }}
                className="btn"
                disabled={this.props.puzzleNumber === PUZZLES.length - 1}
                onClick={(e) => {
                  this.resetLevelStats();
                  this.props.selectPuzzle(this.props.puzzleNumber + 1);
                }}
              >
                Next
                <img src={require("./static/play.svg")} alt="play-button" />
              </motion.button>
            </div>
          </StarModal>
          {/* <Modal
          isOpen={true}
          title={"Well Done"}
          text="Yay!"
          img={Cherries}
          infoText={" You are now ready to free the berry!"}
          levelCompleteSound={this.props.levelCompleteSound}
        >
          <div
            style={{
              display: "flex",
              flexDirection:'column',
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button 
              className="btn" 
              disabled={this.props.puzzleNumber === PUZZLES.length - 1}
              onClick={(e) => {
                this.resetLevelStats();
                this.props.selectPuzzle(this.props.puzzleNumber + 1)
              }}
            >
              Continue
              <img
                src={require("./static/play.svg")}
                alt="play-button"
              />
            </button>
          </div>
        </Modal> */}

          <motion.div
            className="board-content"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
            }}
          >
            <div
              className="board-component"
              style={{
                height: this.state.size * BOX_WIDTH,
                width: this.state.size * BOX_WIDTH,
              }}
            >
              {this.state.pieces.map((piece, index) => {
                let x = piece.x * BOX_WIDTH,
                  y = piece.y * BOX_WIDTH;
                let isWinningPiece = piece.isMain && isWon;
                if (index === this.state.draggingIndex) {
                  let [minX, maxX, minY, maxY] = this.getPieceBounds(piece);
                  if (this.state.offsetX !== null)
                    x += Math.min(maxX, Math.max(minX, this.state.offsetX));
                  if (this.state.offsetY !== null)
                    y += Math.min(maxY, Math.max(minY, this.state.offsetY));
                  }
                return (
                  <Fragment key={index}>
                    <div
                      key={index}
                      onMouseDown={(e) => this.dragStart(index, e)}
                      onTouchStart={(e) => this.dragStart(index, e)}
                      style={{
                        marginTop: y,
                        marginLeft: isWinningPiece ? x + 2 * BOX_WIDTH : x,
                        height: piece.dy * BOX_WIDTH,
                        width: piece.dx * BOX_WIDTH,
                        // Winning piece spins around and gets big enough to cover the screen
                        // transform: isWinningPiece
                        //   ? "opacity ease 250ms"
                        //   : "inherit",
                        animate: isWinningPiece
                          ? "backOutRight 0.35s linear"
                          : "",
                        opacity: isWinningPiece ? "0" : "inherit",
                        zIndex: isWinningPiece ? "15" : "inherit",
                        // Animate movements, but only pieces that aren't currently being dragged
                        transition:
                          index !== this.state.draggingIndex
                            ? isWinningPiece
                              ? "transform 750ms 250ms, opacity 750ms, margin ease-in 250ms"
                              : "margin 250ms"
                            : "",
                        position: "absolute",
                      }}
                    >
                      <div
                        className={
                          "block" + (piece.isMain ? " main-block" : "")
                        }
                      >
                        {/* <span>{index+1}</span> */}
                      </div>
                      <div className="block block-shadow"></div>
                    </div>
                  </Fragment>
                );
              })}
            </div>
            {/* game controls */}
          </motion.div>

          {/* <div style={{ paddingTop: "10px" }} />
        <div>
          <input
            type="button"
            disabled={this.props.puzzleNumber === 0}
            onClick={(e) =>
              this.props.selectPuzzle(this.props.puzzleNumber - 1)
            }
            className="button smallButton"
            value="&#x25C0;&#xFE0E;"
          />
          <div style={{ display: "inline", width: "80px", margin: "5px" }}>
            Level {this.props.puzzleNumber + 1}
          </div>
          <input
            type="button"
            disabled={this.props.puzzleNumber === PUZZLES.length - 1}
            onClick={(e) =>
              this.props.selectPuzzle(this.props.puzzleNumber + 1)
            }
            className="button smallButton"
            value="&#x25B6;&#xFE0E;"
          />
          <span style={{ paddingLeft: "10px" }} />
          <input
            type="button"
            onClick={(e) => this.props.selectPuzzle(null)}
            className="button smallButton"
            value="List"
          />
        </div> */}
        </div>

        <div className="right__content">
          <span className="level-detail-right">
            Level {this.props.puzzleNumber + 1}
          </span>
        </div>
      </div>
    );
  }
}
